import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { convertToCurrencyString } from '../../../utils/currencyUtil';

interface SellerRegistration {
  id: number;
  companyName: string;
  email: string;
  personInCharge: string;
  phoneNumber: string;
  amount: number;
  status: string;
}

const SellerRegistrationPayments: React.FC = () => {
  const columns: ColumnsType<SellerRegistration> = [
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Person In charge',
      dataIndex: 'personInCharge',
      key: 'personInCharge',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount: number) => `${convertToCurrencyString(amount)}`,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ];

  const sellers: readonly any[] | undefined = [];

  return <Table dataSource={sellers} columns={columns} rowKey='id' size='small' />;
};

export default SellerRegistrationPayments;
